import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchCustomerSegmentList = createAsyncThunk("fetchCustomerSegmentList", async ({ channel_uuid, keyword } = {}) => {
	const params = new URLSearchParams({
		channel_uuid: channel_uuid ?? "",
		keyword: keyword ?? "",
	});
	const response = await axiosHttp.get(`customer-segments?${params}`);
	return response.data.data;
});

const CustomerSegmentListSlice = createSlice({
	name: "CustomerSegmentListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchCustomerSegmentList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchCustomerSegmentList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchCustomerSegmentList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default CustomerSegmentListSlice.reducer;
